import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Login from "./Pages/Login/Login";
import Dashboard from "./Pages/Dashboard/Dashboard";
import Reconcilation from "./Pages/Reconcilation/Reconcilation";
import NewReconciliationRun from "./Pages/New Reconciliation Run/NewReconciliationRun";
import BankTransactions from "./Pages/BankTransactions/BankTransactions";
import MatchingRules from "./Pages/Matching Rules/matchingRules";
import ImportTransactions from "./Pages/ImportTransactions/ImportTransactions";
import ImportTransaction1 from "./Pages/ImportTransactions/ImportTranscation1";
import ImportTransaction2 from "./Pages/ImportTransactions/ImportTransaction2";
import ImportTransaction4 from "./Pages/ImportTransactions/ImportTransaction4";
import Workspace from "./Pages/Workspace/Workspace";
import Profile from "./Pages/Profile/Profile";
import Exceptions from "./Pages/Exceptions/Exceptions";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/ImportTransactions" element={<ImportTransactions />} />
        <Route path="/ImportTransaction1" element={<ImportTransaction1 />} />
        <Route path="/ImportTransaction2" element={<ImportTransaction2 />} />
        <Route path="/ImportTransaction4" element={<ImportTransaction4 />} />

        <Route path="/Reconcilation" element={<Reconcilation />} />

        <Route
          path="/Reconcilation/NewReconciliationRun"
          element={<NewReconciliationRun />}
        />
        <Route path="/Reconcilation" element={<Reconcilation />} />
        <Route path="/Reconcilation/Exceptions" element={<Exceptions />} />
        <Route path="/Reconcilation/NewReconciliationRun" element={<NewReconciliationRun />} />
        <Route path="/Reconcilation/MatchingRules" element={<MatchingRules />} />
        <Route path="/bank-transactions" element={<BankTransactions />} />
        <Route path="/bank-transactions/ledger" element={<BankTransactions />} />
        <Route path="/bank-transactions/matched" element={<BankTransactions />} />
        <Route path="/bank-transactions/unmatched" element={<BankTransactions />} />
        <Route path="/data/import-centre" element={<BankTransactions />} />
        <Route path="/data/bank-accounts" element={<Dashboard />} />
        <Route path="/data/data-sources" element={<Dashboard />} />
        <Route path="/approvals" element={<Dashboard />} />
        <Route path="/reports/reconciliation" element={<Reconcilation />} />
        <Route path="/Exceptions" element={<Exceptions />} />
        <Route path="/reports/ageing" element={<Dashboard />} />
        <Route path="/reports/management" element={<Dashboard />} />
        <Route path="/audit-trail" element={<Dashboard />} />
        <Route path="/administration/users" element={<Dashboard />} />
        <Route path="/administration/roles-permissions" element={<Dashboard />} />
        <Route path="/administration/organization" element={<Dashboard />} />
        <Route path="/administration/integrations" element={<Dashboard />} />
        <Route path="/administration/notifications" element={<Dashboard />} />
        <Route path="/administration/security" element={<Dashboard />} />
        <Route path="/Reconcilation/Workspace" element={<Workspace />} />
        <Route path="/my-profile" element={<Profile />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;